import LinkRootBlocks from '../../../components/blocks/LinkRootBlocks.jsx';
import ROUTES from '../../../routes/Routes.js';

export default function LinkrootDescription() {
    return (
        <LinkRootBlocks
            maintitle="¿Qué acción deseas realizar?"
            columnsPerRow={3}
            blocks={[
                { ico: "bi bi-menu-app-fill", title: "Medidas de extención", link: ROUTES.LIST_EXTENSION_UNITS},
                { ico: "bi bi-bar-chart-steps", title: "Nivel instruccional", link: ROUTES.LIST_INSTRUCTIONAL_LEVELS},
                { ico: "bi bi-film", title: "Nivel Multimedia", link: ROUTES.LIST_MULTIMEDIA_LEVELS}
            ]}
        />
    );
}